import { Field, Switch, Label } from "@headlessui/react";
import { FC, Fragment, InputHTMLAttributes } from "react";

type ToggleTextWhitLabelProps =
  | (InputHTMLAttributes<HTMLInputElement> & {
      texto: string;
      textoSecondary?: string;
      checked: boolean;
      onChange: any;
      disabled?: boolean;
      label: string;
    })
  | any;

export const ToggleTextWhitLabel: React.FC<ToggleTextWhitLabelProps> = ({
  texto,
  label,
  checked,
  onChange,
  disabled,
  className,
  textoSecondary,
  ...props
}) => (
  <Fragment>
    <label
      htmlFor={props.id}
      className="block text-sm font-medium leading-6 text-gray-900"
    >
      {label}
    </label>
    <div className="flex justify-end">
      <Field className="flex items-center">
        <Switch
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 data-[checked]:bg-primary-500"
        >
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
          />
        </Switch>
        <Label as="span" className="ml-3 text-sm">
          <span className="font-medium text-gray-900">{texto}</span>{" "}
          <span className="text-gray-500">{textoSecondary}</span>
        </Label>
      </Field>
    </div>
  </Fragment>
);
